import { Component, OnInit } from '@angular/core';
import { TermsService } from '../terms.service';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { AuthService } from '../../../common/shared/services/auth.service';
import { DialogService } from '../../../common/shared/services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../../common/shared/services/navigation.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  currentTermsTranslationKey = '';
  hasValidConsentBoolean = true;

  constructor(
    private _termsService: TermsService,
    private _utilitiesService: UtilitiesService,
    private _authService: AuthService,
    private _dialogService: DialogService,
    private _translateService: TranslateService,
    private _navigationService: NavigationService
  ) { }

  ngOnInit() {
    this._utilitiesService.removeInitAction(0);
    this._utilitiesService.addMinorAction('LoadCurrentTerms');
    this._termsService.loadCurrentTerms().subscribe(
      data => {
        this.currentTermsTranslationKey = this._utilitiesService.getData(data);
        this.currentTermsTranslationKey = this.currentTermsTranslationKey[0].toLowerCase() + this.currentTermsTranslationKey.substring(1);
        this._utilitiesService.removeAction('LoadCurrentTerms');
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );

    if (this._authService.isLoggedIn()) {
      this._utilitiesService.addMinorAction('CheckValidConsent');
      this._termsService.hasValidConsent().subscribe(
        data => {
          this._utilitiesService.removeAction('CheckValidConsent');
          this.hasValidConsentBoolean = this._utilitiesService.getData(data);
        },
        err => {
          this._utilitiesService.removeAction('CheckValidConsent');
          this.hasValidConsentBoolean = false;
        }
      );
    }
  }

  saveConsent() {
    this._utilitiesService.addMinorAction('SaveConsent');
    this._termsService.createConsent().subscribe(
      data => {
        this._utilitiesService.removeAction('SaveConsent');
        if (this._utilitiesService.getData(data)) {
          this._translateService.get(['portal.Terms.Consent.Success']).subscribe((res: string) => {
            this._dialogService.showSuccessDialogWithCallback(
              this.toProfile.bind(this),
              res['portal.Terms.Consent.Success']);
          });
        } else {
          this._translateService.get(['portal.Terms.Consent.Error']).subscribe((res: string) => {
            this._dialogService.showErrorDialogWithBody(res['portal.Terms.Consent.Error']);
          });
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  isLoggedIn() {
    return this._authService.isLoggedIn();
  }

  loadCurrentTermsActive() {
    return this._utilitiesService.isActionActive('LoadCurrentTerms');
  }

  consentActionActive() {
    return this._utilitiesService.isActionActive('SaveConsent');
  }

  hasValidConsent() {
    return this.hasValidConsentBoolean;
  }

  toProfile() {
    this._navigationService.navigateTo('profile');
  }

}
